import React from "react";
import Reveal from "../common/Reveal";

const ClosingCTA = () => {
  return (
    <section className="bg-primary-950 py-16">
      <Reveal className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <p className="break-keep text-xl font-bold leading-relaxed text-white sm:text-2xl">
          MTST는 제조업의 디지털 혁신을 선도하는 맞춤형 기술과 서비스를
          제공합니다.
          <br />
          고객의 비즈니스 환경에 최적화된 솔루션을 통해 스마트 제조의
          미래를 함께 만들어갑니다.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <a
            href="mailto:mtst@mtstech.kr"
            className="inline-flex items-center rounded-md bg-white px-6 py-3 text-base font-semibold text-primary-900 transition-all duration-200 hover:-translate-y-0.5 hover:bg-gray-100 hover:shadow-lg"
          >
            도입 문의
          </a>
        </div>
      </Reveal>
    </section>
  );
};

export default ClosingCTA;
